var map = {
	"./Bitcoin_Encryption.svg": 73472,
	"./Bitcoin_Wallet.svg": 14456,
	"./Blockchain.svg": 48412,
	"./EURT.svg": 60924,
	"./aboutUs.png": 920,
	"./app-store.png": 83340,
	"./apple-and-google.svg": 87696,
	"./apple-pay.svg": 88664,
	"./apple-store.svg": 33064,
	"./arrow-down.svg": 52004,
	"./arrow-left.svg": 63460,
	"./auth.png": 61788,
	"./buy-sell.svg": 6872,
	"./cancel.svg": 39424,
	"./card-background.png": 5992,
	"./card-galileo-mastercard-virtual.png": 92216,
	"./card-galileo-mastercard.png": 9920,
	"./card-galileo-visa-virtual.png": 73912,
	"./card-galileo-visa.png": 84196,
	"./card-galileo.png": 32192,
	"./card-order-no-text-hand-contis.svg": 62824,
	"./card-order-no-text-hand-galileo.png": 8708,
	"./card-order-no-text-hand-galileo.svg": 14496,
	"./card-order-no-text-hand-optimus.png": 95996,
	"./card-order-no-text-hand-optimus.svg": 92528,
	"./card-order-no-text-hand.png": 59668,
	"./card-order-no-text.svg": 98860,
	"./card-promo-no-text.svg": 39292,
	"./card-step-1.png": 16508,
	"./card-step-2.png": 0,
	"./card-step-3.png": 93332,
	"./card-step-4.png": 24328,
	"./card-step-5.png": 76836,
	"./card-step-mobile-1.png": 17744,
	"./card-step-mobile-2.png": 99839,
	"./card-step-mobile-3.png": 46844,
	"./card-step-mobile-4.png": 49944,
	"./card-step-mobile-5.png": 80572,
	"./card.svg": 9792,
	"./cashback.svg": 14256,
	"./chat.svg": 43640,
	"./check.svg": 29024,
	"./cl-card-galileo-mastercard-virtual.png": 31772,
	"./cl-card-galileo-mastercard.png": 45048,
	"./cl-card-galileo-visa-virtual.png": 69260,
	"./cl-card-galileo-visa.png": 31064,
	"./cl-card-monavate.png": 52180,
	"./cl-logo-black.svg": 95044,
	"./cl-logo.svg": 44248,
	"./clipboard.svg": 5452,
	"./close.svg": 13424,
	"./collapse-down.svg": 38580,
	"./credit-card.svg": 90976,
	"./credit-limit.svg": 24332,
	"./crypto-wallets.svg": 78344,
	"./cryptodraft-promo.png": 10288,
	"./dashboard-bg.svg": 9168,
	"./date-outline.svg": 97412,
	"./document.svg": 41444,
	"./done.svg": 39584,
	"./dotted-line-bg-down.svg": 92748,
	"./dotted-line-bg-up.svg": 22940,
	"./drag_drop.svg": 8376,
	"./email.svg": 25996,
	"./error.svg": 99668,
	"./eye.svg": 42860,
	"./fiat_Wallet.svg": 7308,
	"./fund.svg": 6628,
	"./gift.svg": 62776,
	"./google-pay.svg": 69116,
	"./google-play.png": 24900,
	"./google-store.svg": 97168,
	"./ledger-logo.svg": 6268,
	"./ledger-mobile-logo.png": 26400,
	"./left-arrow.svg": 35644,
	"./loans-promo.png": 1979,
	"./locked.svg": 58864,
	"./logo-black.svg": 60796,
	"./logo.svg": 69532,
	"./loyalty-banner.png": 72308,
	"./loyalty-bg.png": 60428,
	"./loyalty_program.svg": 26496,
	"./mailing_address.svg": 56824,
	"./main-card.png": 29760,
	"./maintenance.png": 47164,
	"./masterCardSecurity.svg": 52236,
	"./mastercard-logo.svg": 43500,
	"./mastercard-no-text.svg": 62576,
	"./mastercard.svg": 99460,
	"./maxwell-average-income-wallet.png": 78179,
	"./maxwell-modal-image.png": 24320,
	"./maxwell-review_application.png": 35944,
	"./maxwellLogo.svg": 6360,
	"./menu-accounts-active.svg": 24916,
	"./menu-accounts.svg": 784,
	"./menu-card-active.svg": 58796,
	"./menu-card.svg": 97140,
	"./menu-loans-active.svg": 26560,
	"./menu-loans.svg": 29588,
	"./menu-settings-active.svg": 33412,
	"./menu-settings.svg": 33032,
	"./menu.svg": 11072,
	"./modal-exchange.svg": 96356,
	"./modal-send.svg": 84576,
	"./nike.svg": 44252,
	"./no-deposit.png": 13868,
	"./no-transactions.svg": 67784,
	"./no_transactions_icon.png": 54940,
	"./optimus_physical.png": 13132,
	"./order-card-galileo.png": 94812,
	"./order-card-mastercard.png": 98705,
	"./order-card-optimus-virtual.png": 83272,
	"./order-card-visa.png": 76949,
	"./otc.png": 51272,
	"./payment-banner-info.png": 88536,
	"./payment-banner.png": 12024,
	"./phone.svg": 68788,
	"./promo-background.svg": 21136,
	"./promo-card-img.svg": 99872,
	"./promo-gradient.png": 89544,
	"./promo-image-1.png": 14408,
	"./promo-image-2.png": 97484,
	"./promo-image-3.png": 55492,
	"./promo-us-image-1.png": 37916,
	"./promo-us-image-2.png": 96684,
	"./promo-us-image-3.png": 17028,
	"./question_mark_icon.svg": 27856,
	"./refresh.svg": 72624,
	"./replacement.png": 8664,
	"./report-disabled.svg": 38672,
	"./report.svg": 97144,
	"./reportMastercard.png": 27904,
	"./reportMastercard.svg": 43056,
	"./reportVisacard.svg": 19832,
	"./right-arrow.svg": 74460,
	"./security.svg": 12900,
	"./shop.svg": 95412,
	"./sort.svg": 636,
	"./staking-promo-new.png": 73468,
	"./starbucks.svg": 98564,
	"./success.svg": 45472,
	"./switch.svg": 89468,
	"./timeout.svg": 8724,
	"./transaction-success.svg": 2144,
	"./uber.svg": 2860,
	"./uk-us-eur.svg": 82224,
	"./upgrade.png": 24948,
	"./us-card-bg-disabled.png": 22584,
	"./us-card-bg-virtual.png": 32652,
	"./us-card-bg.png": 94168,
	"./verif.svg": 82384,
	"./visa-logo-dark.svg": 4741,
	"./visa-logo.svg": 71756,
	"./visa.svg": 29652,
	"./visaSecurity.svg": 4800,
	"./wallet.svg": 35628,
	"./warning.png": 69220,
	"./warning.svg": 67512,
	"./whitelist-adress.svg": 96272,
	"./withdraw.svg": 4152,
	"./yield-banner.png": 83420
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80844;